import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import {
  Multiselect,
  EnhancedAutocomplete,
  CreateValidateTextField,
  LocationAutocomplete,
} from "..";
import { Dialog, DialogTitle, FilledInput, Snackbar, Alert } from "@mui/material";
function JobCreate(props) {
  const { userType, username, updateTable, setUpdateTable } = props;

  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [skills, setSkills] = useState([]);

  const [jobDetails, setJobDetails] = useState("");
  const [howToApply, setHowToApply] = useState("");

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const currentDay = currentDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedCurrentDate = `${currentYear}-${currentMonth}-${currentDay}`;
  const [startDate, setStartDate] = useState(formattedCurrentDate);

  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate() + 1);
  const nextYear = nextDate.getFullYear();
  const nextMonth = (nextDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const nextDay = nextDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedNextDate = `${nextYear}-${nextMonth}-${nextDay}`;
  const [endDate, setEndDate] = useState(formattedNextDate);

  const [applyLink, setApplyLink] = useState("");
  const [companyLink, setCompanyLink] = useState("");

  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const [jobLevel, setJobLevel] = useState([]);
  const [jobType, setJobType] = useState([]);
  const [jobIndustry, setJobIndustry] = useState([]);

  const [availableSkills, setAvailableSkills] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const handleCreateJob = (event, draft) => {
    event.preventDefault();

    const body = new FormData();
    body.append("username", username);
    body.append("userType", userType);
    body.append("title", title);
    body.append("companyName", userType === "admin" ? companyName : username);
    body.append("location", location);
    body.append("jobDetails", jobDetails);
    body.append("startDate", startDate.toString());
    body.append("endDate", endDate.toString());
    body.append("applyLink", applyLink);
    body.append("companyLink", companyLink);
    body.append("applyDetails", howToApply);
    body.append("jobLevel", jobLevel);
    body.append("skills", skills);
    body.append("user_type", userType);
    body.append("jobType", jobType);
    body.append("jobIndustry", jobIndustry);
    body.append("draft", draft);

    axios.post("/company/createJob", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenCreateDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  useEffect(() => {
    axios.get("/company/skills").then((res) => {
      const data = res.data;
      if (data.success) {
        setAvailableSkills(data.skills);
      } else {
        return setAvailableSkills([]);
      }
    });
  }, []);

  const jobLevelData = {
    options: ["Internship", "Co-op", "Full-Time", "Part-Time"],
    value: jobLevel,
    setter: setJobLevel,
    placeholder: "Select job level (at least one)",
  };

  const jobTypeData = {
    options: ["In Person", "Remote", "Hybrid"],
    value: jobType,
    setter: setJobType,
    placeholder: "Select job type (at least one)",
  };

  const industryData = {
    options: [
      "Software Development",
      "Software Engineering",
      "Project Management",
      "Other",
    ],
    value: jobIndustry,
    setter: setJobIndustry,
    placeholder: "Select industry (at least one)",
  };

  function makeMultiselect(type) {
    let data = {};
    if (type === "Job Levels") {
      data = jobLevelData;
    } else if (type === "Job Types") {
      data = jobTypeData;
    } else if (type === "Job Industries") {
      data = industryData;
    } else {
      return;
    }

    return (
      <div className="[&>div>div]:mb-2">
        <Multiselect
          options={data.options}
          selectedValue={data.value}
          selectedSetter={data.setter}
        />
      </div>
    );
  }

  const resetHooks = () => {
    setTitle("");
    setLocation("");
    setCompanyName("");
    setJobLevel([]);
    setJobType([]);
    setJobIndustry([]);
    setSkills([]);
    setStartDate(formattedCurrentDate);
    setEndDate(formattedNextDate);
    setJobDetails("");
    setHowToApply("");
    setApplyLink("");
    setCompanyLink("");
  };

  function showCreateDialog() {
    return (
      <Dialog open={openCreateDialog} maxWidth={false}>
        <DialogTitle className="JobCreate-title mx-auto text-2xl font-bold font-brand-primary">
          Create Job Posting
        </DialogTitle>
        <div className="JobCreate-modalContainer flex w-fit mb-4 mx-4">
          <div className="JobCreate-modalLeftContainer flex flex-col w-fit">
            <div className="JobCreate-titleContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-title text-lg font-brand-primary">
                Title *
              </div>
              <CreateValidateTextField
                placeholder="Junior Software Engineer"
                pattern="(?=.*\w).+"
                value={title}
                setter={setTitle}
                errorMessage={"Invalid Title."}
                required={true}
                maxLength={250}
              />
            </div>
            <div className="JobCreate-locationContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-locationTitle text-lg font-brand-primary">
                Location *
              </div>
              <LocationAutocomplete
                idAndClassName="JobCreate-LocationSearch"
                locationValue={location}
                setLocationValue={setLocation}
                key={200}
              />
            </div>
            <div className="JobCreate-jobDescriptionContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-jobDescriptionTitle text-lg font-brand-primary">
                Job Description *
              </div>
              <textarea
                value={jobDetails}
                onChange={(event) => {
                  if (event.target.value.length <= 10000) {
                    setJobDetails(event.target.value);
                  }
                }}
                className="rounded-xl bg-white p-2 border border-gray-300"
                type="textarea"
                placeholder="Please add details about the job here!"
                required={true}
              />
            </div>
            <div className="JobCreate-howToApplyContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-howToApplyTitle text-lg font-brand-primary">
                How To Apply *
              </div>
              <textarea
                value={howToApply}
                onChange={(event) => {
                  if (event.target.value.length <= 1000) {
                    setHowToApply(event.target.value);
                  }
                }}
                className="rounded-xl p-2  border border-gray-300"
                type="textarea"
                placeholder="Please add details about how to apply to the job here!"
                required={true}
              />
            </div>
            <div className="JobCreate-dateContainer flex justify-between">
              <div className="JobCreate-startDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="JobCreate-startDateTitle text-lg font-brand-primary">
                  Posting Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="JobCreate-endDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="JobCreate-endDateTitle text-lg font-brand-primary">
                  Posting End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
            {userType == "admin" && (
              <div className="JobCreate-companyContainer flex flex-col w-96 mx-4 mb-2">
                <div className="JobCreate-companyTitle text-lg font-brand-primary">
                  Company Name *
                </div>
                <CreateValidateTextField
                  placeholder="Company"
                  pattern="(?=.*\w).+"
                  value={companyName}
                  setter={setCompanyName}
                  errorMessage={"Invalid Company."}
                  required={true}
                />
              </div>
            )}
          </div>
          <div className="JobCreate-modalRightContainer flex flex-col w-fit">
            <div className="JobCreate-applicationLinkContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-applicationLinkTitle text-lg font-brand-primary">
                Application Link *
              </div>
              <CreateValidateTextField
                placeholder="https://yoursite.com or youremail@email.com"
                pattern="(https:\/\/)?(www\.)?((?=[a-zA-Z])[a-zA-Z0-9_-]+(?<=[a-zA-Z])\.)+[a-zA-Z]{2,}\/?(\/?[a-zA-Z0-9-#?_]*)*|[a-zA-Z_.%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                value={applyLink}
                setter={setApplyLink}
                errorMessage={"Invalid Link. Must be Link or Email."}
                required={true}
                maxLength={1000}
              />
            </div>
            <div className="JobCreate-companyLinkContainer flex flex-col w-96 mx-4 mb-2">
              <div className="JobCreate-companyLinkTitle text-lg font-brand-primary">
                Company Link *
              </div>
              <CreateValidateTextField
                placeholder="https://yoursite.com"
                pattern="(https:\/\/)?(www\.)?((?=[a-zA-Z])[a-zA-Z0-9_-]+(?<=[a-zA-Z])\.)+[a-zA-Z]{2,}\/?(\/?[a-zA-Z0-9-#?_]*)*"
                value={companyLink}
                setter={setCompanyLink}
                errorMessage={"Invalid Link. Must be Link."}
                required={true}
              />
            </div>
            <div className="JobCreate-jobLevelContainer flex flex-col w-96 mx-4">
              <div className="JobCreate-JobLevelTitle text-lg font-brand-primary">
                Job Level (Please choose at least one): *
              </div>
              {makeMultiselect("Job Levels")}
            </div>
            <div className="JobCreate-jobTypeContainer flex flex-col w-96 mx-4">
              <div className="JobCreate-jobTypeTitle text-lg font-brand-primary">
                Job Type (Please choose at least one): *
              </div>
              {makeMultiselect("Job Types")}
            </div>
            <div className="JobCreate-industriesContainer flex flex-col w-96 mx-4">
              <div className="JobCreate-industriesTitle text-lg font-brand-primary">
                Industries (Please choose at least one): *
              </div>
              {makeMultiselect("Job Industries")}
            </div>
            <div className="JobCreate-jobSkillsContainer flex flex-col w-96 mx-4 mb-4">
              <div className="JobCreate-jobSkillsTitle text-lg font-brand-primary">
                Job Skill(s):
                <div className="[&>div>div]:mt-1">
                  <EnhancedAutocomplete
                    placeholder="Select skill(s)"
                    options={availableSkills}
                    selectedValue={skills}
                    selectedSetter={setSkills}
                    isMultiSelect={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="JobCreate-buttonContainer flex justify-between px-8 mb-4">
          <button
            type="button"
            className="primary-button bg-brand-secondary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateJob(event, true)}
          >
            Save As Draft
          </button>
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3"
            onClick={(event) => handleCreateJob(event, false)}
          >
            Create Job
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary  mb-2 h-11 pt-3"
            onClick={resetHooks}
          >
            Reset
          </button>
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenCreateDialog(false);
              resetHooks();
            }}
          >
            Cancel
          </button>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }
          }
        >
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }
            }
            severity="error"
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="JobCreate-container">
      {showCreateDialog()}
      <button
        type="button"
        className="JobCreate-button search-button px-4 h-11 mb-4 mr-4 text-center py-2"
        onClick={() => setOpenCreateDialog(true)}
      >
        Create Job Posting
      </button>
    </div>
  );
}

JobCreate.propTypes = {
  userType: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  updateTable: PropTypes.bool.isRequired,
  setUpdateTable: PropTypes.func.isRequired,
};

export default JobCreate;
